import { createFileRoute, redirect } from '@tanstack/react-router';
import { Landing } from '@/pages';

/**
 * Index Route - Landing Page
 * Redirects authenticated users to dashboard
 * Shows landing page for unauthenticated users
 */
export const Route = createFileRoute('/_public/')({
  beforeLoad: async ({ context }) => {
    // Wait for auth to finish loading before making redirect decision
    if (context.auth.isLoading) {
      return;
    }

    // Redirect authenticated users to dashboard
    if (context.auth.isAuthenticated) {
      throw redirect({
        to: '/dashboard',
      });
    }
  },
  component: Landing,
});
